import { BufferAttribute, BufferGeometry } from "three"

// Builds the BufferGeometry for the particle system.
export default function createParticlesGeometry(baseGeometry, particlesData, count, targetPositionsArray) {
    const geometry = new BufferGeometry()
    geometry.setDrawRange(0, count)
    geometry.setAttribute('aParticlesUv', new BufferAttribute(particlesData.uvArray, 2))

    if (baseGeometry.attributes.color) {
        geometry.setAttribute('aColor', baseGeometry.attributes.color)
    }
    geometry.setAttribute('aSize', new BufferAttribute(particlesData.sizesArray, 1))
    geometry.setAttribute('position', new BufferAttribute(baseGeometry.attributes.position.array, 3))

    geometry.setAttribute('aPositionTarget', new BufferAttribute(targetPositionsArray, 3))

    return geometry
}
